import { Component, Input } from "@angular/core";

import { Community, CommunityListConfig, User } from "../../../../models";
import { CommunityListResult } from "../../../../interfaces";
import { CommunityService, ProfileService } from "../../../../services";

/*
  config.type are as follows
  all communities = AllCommunitiesLatestFeed
  communities that the user is member of = AllCommunitiesMembershipFeed
  communities searched = AllCommunitiesSearchFeed
  trending community communities = CommunityCommunitiesTrendingFeed
*/

@Component({
  selector: "community-list",
  templateUrl: "./community-list.component.html",
  styleUrls: [
    "./community-list.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class CommunityListComponent {
  constructor(
    private communityService: CommunityService,
    private profileService: ProfileService
  ) {}

  private query: CommunityListConfig;
  public results: Community[];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;

  @Input() limit: number;
  @Input() currentUser: User;
  @Input()
  set config(config: CommunityListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.runQuery();
    }
  }

  public setTagTo(event: any) {
    this.query.filters.tag = event;
    this.currentPage = 1;
    this.runQuery();
  }

  public fetchAllCommunities() {
    this.communityService
      .findMany(this.query)
      .subscribe((data: CommunityListResult) => {
        this.results = data.communities;
        this.totalPages = data.pages.total;
        this.loading = false;
      });
  }

  public fetchSearchedCommunities() {
    this.communityService
      .searchOne(this.query)
      .subscribe((data: CommunityListResult) => {
        this.results = data.communities;
        this.totalPages = data.pages.total;
        this.loading = false;
      });
  }

  public fetchUserCommunities() {
    this.profileService
      .findUserCommunities(this.currentUser, this.query)
      .subscribe((data: CommunityListResult) => {
        this.results = data.communities;
        this.totalPages = data.pages.total;
        this.loading = false;
      });
  }

  public setPageTo(pageNumber: number) {
    this.currentPage = pageNumber;
    this.runQuery();
  }

  public runQuery() {
    this.loading = true;
    this.results = [];

    if (this.limit) {
      this.query.filters.limit = this.limit;
      this.query.filters.offset = this.limit * (this.currentPage - 1);
    }

    switch (this.query.type) {
      case "AllCommunitiesSearchFeed":
        this.fetchSearchedCommunities();
        break;
      case "AllCommunitiesMembershipFeed":
        this.fetchUserCommunities();
        break;
      default:
        this.fetchAllCommunities();
    }

    window.scroll(0, 0);
  }
}
